@for (block of blocks; track block.key; let i = $index) {
  <app-block-item
    [block]="block"
    [isFirst]="i === 0"
    [isLast]="i === blocks.length - 1"
    [blockNumber]="getBlockNumber(block)"
    [localLogoUrl]="getLocalLogoUrl(block)"
    (moveUp)="moveBlockUp(i)"
    (moveDown)="moveBlockDown(i)"
    (edit)="editBlock(block)"
    (remove)="deleteBlock(block)"
    (togglePublish)="togglePublish(block)"
    (toggleCollapsible)="toggleCollapsible(block)">
  </app-block-item>
}
<div class="add-block">
  <button class="add-block-btn" (click)="addBlock()">
    <mat-icon>add_circle_outline</mat-icon>
    Inhaltsblock hinzufügen
  </button>
</div>
